import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TeamsPhoneNumberAssignment, TeamsPhoneNumberAssignmentRef } from '../../../shared/models/generated/ziroModels';
import { Nvp } from '../../../shared/models/nvp';
import { AuditHeaderService } from '../../../shared/services/audit-header.service';

@Injectable()
export class MicrosoftPhoneNumberAssignmentsResource {
  private http = inject(HttpClient);
  private auditHeaderService = inject(AuditHeaderService);

  get(upn: string, tenantId: string): Observable<TeamsPhoneNumberAssignment> {
    return this.http.get<TeamsPhoneNumberAssignment>(this._buildUrl(tenantId, upn));
  }

  post(upn: string, body: TeamsPhoneNumberAssignment, tenantId: string): Observable<TeamsPhoneNumberAssignmentRef> {
    return this.http.post<TeamsPhoneNumberAssignmentRef>(this._buildUrl(tenantId, upn), body);
  }

  put(upn: string, body: TeamsPhoneNumberAssignment, tenantId: string): Observable<void> {
    return this.http.put<void>(this._buildUrl(tenantId, upn), body);
  }

  delete(upn: string, tenantId: string, auditTags?: Nvp[]): Observable<void> {
    const httpOptions = this._buildHttpOptions(auditTags);
    return this.http.delete<void>(this._buildUrl(tenantId, upn), httpOptions);
  }

  private _buildHttpOptions(auditTags: Nvp[]): { headers?: HttpHeaders } {
    return auditTags ? { headers: this.auditHeaderService.buildHeader(auditTags) } : {};
  }

  private _buildUrl(tenantId: string, upn: string): string {
    return `/services/microsoft/teams-user-management/tenants/${tenantId}/teams-phone-number-assignment/${encodeURIComponent(upn)}`;
  }
}
